<header-title [model]="headerTitle"></header-title>


<section class="card mt-4">
    <header class="card-header">
        <h3><i class="fas fa-tasks me-3"></i>Register new user</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <form (submit)="register()" #registerForm="ngForm">
                <div class="div">
                    <div class="div">
                        <error-message [errors]="errors"></error-message>
                        <h5 class="mt-3 text-primary">User Details</h5>
                        <div class="row mt-3">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Email
                                    </label>
                                    <input type="email" id="email" name="email" class="form-control" [(ngModel)]="newUser.email" placeholder="newuser@domain.com"
                                           required #email="ngModel" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" (blur)="checkEmail()" />
                                    <div *ngIf="email.errors && (email.dirty || email.touched || submitAttempt)">
                                        <label class="error" [hidden]="!email.errors.required">Email is a required field.</label>
                                        <label class="error" [hidden]="!email.errors.pattern">Not a valid email address.</label>
                                    </div>
                                    <div *ngIf="!isEmailValid">
                                        <label class="error">Email is already in use.</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        First name
                                    </label>
                                    <input type='text' class="form-control" [(ngModel)]="newUser.firstName" name="firstName" required #firstName="ngModel" />
                                    <div *ngIf="firstName.errors && (firstName.dirty || firstName.touched || submitAttempt)">
                                        <label class="error" [hidden]="!firstName.errors.required">First name is a required field.</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Last name
                                    </label>
                                    <input class="form-control" [(ngModel)]="newUser.lastName" name="lastName" #lastName="ngModel" required />
                                    <div *ngIf="lastName.errors && (lastName.dirty || lastName.touched || submitAttempt)">
                                        <label class="error" [hidden]="!lastName.errors.required">Last name is a required field.</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Phone Number
                                    </label>
                                    <input type='text' class="form-control" [(ngModel)]="newUser.phoneNr" name="phoneNr" #phoneNr="ngModel" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Mobile Number
                                    </label>
                                    <input type='text' class="form-control" [(ngModel)]="newUser.mobileNr" name="mobileNr" #mobileNr="ngModel" />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">
                                        Notes
                                    </label>
                                    <textarea class="form-control" [(ngModel)]="newUser.notes" name="notes"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="div" *ngIf="companyId">
                        <h5 class="mt-3 text-primary">Add User to {{companyDetailsModel?.legalName}}</h5>
                        <div class="row form-group">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="col-form-label">User Type</label>
                                    <select name="userTypeId" class="form-select" [(ngModel)]="userType" required #userTypeSelect="ngModel">
                                        <option *ngFor="let userType of userTypes" [value]="userType.id">{{ userType.description }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <label class="col-form-label">&nbsp;</label>
                                    <div *ngIf="userTypeSelect.errors && (userTypeSelect.dirty || userTypeSelect.touched || submitAttempt)">
                                        <p class="text-warning" [hidden]="!userTypeSelect.errors.required">User Type must be selected to save this user to the company.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer class="panel-footer">
                        <div class="row mt-3">
                            <div class="col d-flex justify-content-between">
                                <button class="btn btn-outline-primary ml-1" type="button" (click)="onBack()">Back</button>
                                <button class="btn btn-success" type="submit">Create</button>
                            </div>
                        </div>
                    </footer>
                </div>
            </form>
        </div>
        </div>
</section>
